import React, { useContext, useRef, useEffect, useState } from "react";
import { motion } from "framer-motion";
import { MdOutlineCancel, MdOutlineShoppingCart } from "react-icons/md";
import HeaderTitle from "../HederTitle/HeaderTitle";
import axios from "axios";
import "../Videos/Videos.css";
import { ShopContext } from "../../Context/ShopContext";
import { backend_url } from "../../App";
import { FaVolumeMute, FaVolumeUp } from "react-icons/fa";
import { Link } from "react-router-dom";
import LazyVideo from "../LazyVideo/LazyVideo";

const Videos = () => {
  const { addToCart } = useContext(ShopContext);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(
    selectedVideo?.productIds?.[0] || {}
  );
  const [videos, setVideos] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [positionIndexes, setPositionIndexes] = useState([0, 1, 2]);

  const [isMuted, setIsMuted] = useState(true);

  const toggleMute = () => {
    setIsMuted((prev) => !prev);
  };

  // Fetch videos from backend
  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const res = await axios.get(`${backend_url}/api/browseVideos`);
        setVideos(res.data);
      } catch (error) {
        console.error("Error fetching videos:", error);
      }
    };

    fetchVideos();
  }, []);

  // Lock body scroll when modal is open
  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => (document.body.style.overflow = "auto");
  }, [isModalOpen]);

  const handleVideoClick = (video) => {
    setSelectedVideo(video);

    // Reset selectedProduct to the first product of the new video
    setSelectedProduct(video.productIds?.[0] || {});

    const index = videos.findIndex((v) => v._id === video._id);
    setPositionIndexes([
      (index - 1 + videos.length) % videos.length,
      index,
      (index + 1) % videos.length,
    ]);

    setIsModalOpen(true);
  };

  // Handle next and back buttons for sliding
  // const handleNext = () => {
  //   setPositionIndexes((prevIndexes) =>
  //     prevIndexes.map((prevIndex) => (prevIndex + 1) % videos.length)
  //   );
  // };

  // const handleBack = () => {
  //   setPositionIndexes((prevIndexes) =>
  //     prevIndexes.map(
  //       (prevIndex) => (prevIndex - 1 + videos.length) % videos.length
  //     )
  //   );
  // };

  // Next
  const handleNext = () => {
    setPositionIndexes((prevIndexes) =>
      prevIndexes.map((prevIndex) => (prevIndex + 1) % videos.length)
    );
    const centerIndex = (positionIndexes[1] + 1) % videos.length;
    const newVideo = videos[centerIndex];
    setSelectedVideo(videos[centerIndex]);
    setSelectedProduct(newVideo.productIds?.[0] || {});
  };

  // Back
  const handleBack = () => {
    setPositionIndexes((prevIndexes) =>
      prevIndexes.map(
        (prevIndex) => (prevIndex - 1 + videos.length) % videos.length
      )
    );

    const centerIndex =
      (positionIndexes[1] - 1 + videos.length) % videos.length;
    const newVideo = videos[centerIndex];
    setSelectedVideo(videos[centerIndex]);
    setSelectedProduct(newVideo.productIds?.[0] || {});
  };

  const handleRelatedVideoClick = (clickedIndex) => {
    const newSelectedVideo = videos[clickedIndex];

    setSelectedVideo(newSelectedVideo);

    setPositionIndexes([
      (clickedIndex - 1 + videos.length) % videos.length,
      clickedIndex,
      (clickedIndex + 1) % videos.length,
    ]);
  };

  const positions = ["left", "center", "right"];

  const cardVariants = {
    center: { x: "0%", scale: 1, zIndex: 5 },
    left: { x: "-170%", scale: 0.8, zIndex: 3 },
    right: { x: "170%", scale: 0.8, zIndex: 3 },
  };

  const containerRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const handleMouseDown = (e) => {
    setIsDragging(true);
    setStartX(e.pageX - containerRef.current.offsetLeft);
    setScrollLeft(containerRef.current.scrollLeft);
    document.body.style.cursor = "grabbing"; // Change cursor for entire body
    document.body.style.userSelect = "none"; // Disable text selection during drag
  };

  const handleMouseUp = () => {
    setIsDragging(false);
    document.body.style.cursor = "";
    document.body.style.userSelect = "";
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - containerRef.current.offsetLeft;
    const walk = (x - startX) * 3; // Faster drag
    containerRef.current.scrollLeft = scrollLeft - walk;
  };

  const handleTouchStart = (e) => {
    setIsDragging(true);
    setStartX(e.touches[0].pageX - containerRef.current.offsetLeft);
    setScrollLeft(containerRef.current.scrollLeft);
  };

  const handleTouchMove = (e) => {
    if (!isDragging) return;
    const x = e.touches[0].pageX - containerRef.current.offsetLeft;
    const walk = (x - startX) * 3;
    containerRef.current.scrollLeft = scrollLeft - walk;
  };

  const handleTouchEnd = () => {
    setIsDragging(false);
  };

  return (
    <>
      {/* ── Section wrapper ── */}
      <div
        className="relative overflow-hidden px-4 sm:px-8 pt-8 pb-10"
        style={{ background: "linear-gradient(180deg, #F6F1FE 0%, #F6F1FE 60%, #ffffff 100%)" }}
      >
        {/* Faint dot grid */}
        <div
          className="absolute inset-0 opacity-[0.04] pointer-events-none"
          style={{
            backgroundImage: "radial-gradient(circle, #8353C6 1px, transparent 1px)",
            backgroundSize: "24px 24px",
          }}
        />

        {/* Header */}
        <div className="relative flex flex-col items-center w-full mb-6">
          <h1><HeaderTitle Header="Browse By Videos" /></h1>
          <p className="text-sm text-purple-500 font-medium tracking-wide -mt-2">
            Watch. Fall in love. Shop.
          </p>
        </div>

        <div className="videos-container relative">
          {/* Left / right fade edges */}
          <div className="pointer-events-none absolute left-0 top-0 h-full w-10 z-10"
               style={{ background: "linear-gradient(to right, #F6F1FE, transparent)" }} />
          <div className="pointer-events-none absolute right-0 top-0 h-full w-10 z-10"
               style={{ background: "linear-gradient(to left, #F6F1FE, transparent)" }} />

          {/* Scrollable cards */}
          <div
            ref={containerRef}
            onMouseDown={handleMouseDown}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseUp}
            onMouseMove={handleMouseMove}
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
            className="relative overflow-x-auto overflow-y-hidden"
            style={{ scrollbarWidth: "none" }}
          >
            <div
              className={`flex flex-col md:flex-row gap-5 py-3 w-full ${
                isDragging ? "cursor-grabbing" : "cursor-grab"
              }`}
            >
              {videos.map((video, index) => (
                <div
                  key={index}
                  onClick={(e) => {
                    if (isDragging) { e.preventDefault(); e.stopPropagation(); return; }
                    handleVideoClick(video);
                  }}
                  className="group flex-shrink-0 w-64 sm:w-72 rounded-2xl overflow-hidden cursor-pointer
                             shadow-md hover:shadow-[0_8px_32px_rgba(124,58,237,0.25)]
                             hover:-translate-y-2 transition-all duration-300
                             border-2 border-transparent hover:border-purple-300
                             bg-white"
                >
                  {/* Video */}
                  <div className="relative h-96 overflow-hidden">
                    <LazyVideo
                      src={video.videoUrl}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />

                    {/* Gradient overlay — stronger at bottom */}
                    <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/10 to-transparent" />

                    {/* Play button — purple gradient */}
                    <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      <div
                        className="w-14 h-14 rounded-full flex items-center justify-center shadow-xl"
                        style={{ background: "linear-gradient(135deg, #8353C6, #9E79D2)" }}
                      >
                        <svg className="w-6 h-6 text-white ml-1" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M8 5v14l11-7z" />
                        </svg>
                      </div>
                    </div>

                    {/* Discount badge — top left */}
                    {video.productIds?.[0]?.old_price && (
                      <div className="absolute top-3 left-3 bg-green-500 text-white text-[10px] font-bold px-2 py-0.5 rounded-full shadow">
                        {video.productIds?.[0]?.new_price}% OFF
                      </div>
                    )}

                    {/* Product info — bottom */}
                    <div className="absolute bottom-0 left-0 right-0 p-3">
                      <p className="text-white font-semibold text-sm leading-snug line-clamp-2 drop-shadow">
                        {video.productIds?.[0]?.name}
                      </p>
                      <div className="flex items-center gap-2 mt-1">
                        <span
                          className="text-white font-bold text-sm px-2 py-0.5 rounded-full"
                          style={{ background: "rgba(124,58,237,0.7)" }}
                        >
                          ₹{calculateDiscountPrice(video)}
                        </span>
                        {video.productIds?.[0]?.old_price && (
                          <span className="text-gray-300 line-through text-xs">
                            ₹{video.productIds?.[0]?.old_price}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Video Modal */}
        {isModalOpen && selectedVideo && (
          <div className="fixed z-50 flex items-center justify-center bg-black/90 h-screen w-screen top-0 left-0 overflow-hidden">

            {/* ── Left side card (large screens only, pinned to left edge) ── */}
            <div
              className="hidden lg:flex absolute left-3 top-1/2 -translate-y-1/2 z-[10]
                         w-[10%] h-[60%] rounded-xl overflow-hidden cursor-pointer group"
              onClick={() => {
                handleRelatedVideoClick(positionIndexes[0]);
                setSelectedProduct(videos[positionIndexes[0]]?.productIds?.[0] || {});
              }}
            >
              <video
                className="w-full h-full object-cover opacity-60 group-hover:opacity-90 transition-opacity"
                src={videos[positionIndexes[0]]?.videoUrl}
                loop playsInline muted
              />
              <p className="absolute bottom-2 left-0 right-0 text-white text-[10px] text-center px-1 drop-shadow line-clamp-2">
                {videos[positionIndexes[0]]?.productIds?.[0]?.name}
              </p>
            </div>

            {/* ── Right side card (large screens only, pinned to right edge) ── */}
            <div
              className="hidden lg:flex absolute right-3 top-1/2 -translate-y-1/2 z-[10]
                         w-[10%] h-[60%] rounded-xl overflow-hidden cursor-pointer group"
              onClick={() => {
                handleRelatedVideoClick(positionIndexes[2]);
                setSelectedProduct(videos[positionIndexes[2]]?.productIds?.[0] || {});
              }}
            >
              <video
                className="w-full h-full object-cover opacity-60 group-hover:opacity-90 transition-opacity"
                src={videos[positionIndexes[2]]?.videoUrl}
                loop playsInline muted
              />
              <p className="absolute bottom-2 left-0 right-0 text-white text-[10px] text-center px-1 drop-shadow line-clamp-2">
                {videos[positionIndexes[2]]?.productIds?.[0]?.name}
              </p>
            </div>

            {/* ── Center Modal ── */}
            <motion.div
              className="relative bg-white rounded-none sm:rounded-2xl shadow-2xl overflow-hidden z-[20]
                         w-full h-full
                         sm:w-[72%] sm:h-[86%]
                         md:w-[68%] md:h-[84%]
                         lg:w-[56%] lg:h-[82%]
                         flex flex-col"
              initial={{ scale: 0.95, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.3 }}
            >
              {/* Close button — top right of modal */}
              <button
                onClick={(e) => { e.stopPropagation(); setIsModalOpen(false); }}
                className="absolute top-3 right-3 z-20 w-8 h-8 flex items-center justify-center rounded-full bg-black/40 text-white hover:bg-black/70 transition text-sm font-bold"
              >
                ✕
              </button>

              {/* ── Mobile layout (< sm): full-screen video + overlay ── */}
              <div className="flex sm:hidden w-full h-full relative">
                <video
                  className="w-full h-full object-cover"
                  src={selectedVideo.videoUrl}
                  autoPlay loop muted={isMuted} playsInline
                />
                {/* gradient overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />

                {/* Product info overlay */}
                <div className="absolute bottom-0 left-0 right-0 p-4 pb-6">
                  <p className="text-white font-semibold text-sm truncate drop-shadow">
                    {selectedProduct.name}
                  </p>
                  <p className="text-purple-300 font-bold text-sm mt-0.5">
                    ₹{selectedProduct.old_price && Math.round((selectedProduct.old_price * (100 - selectedProduct.new_price)) / 100)}
                    <span className="text-gray-300 line-through text-xs ml-2">₹{selectedProduct.old_price}</span>
                    <span className="ml-1 text-green-400 text-xs">({selectedProduct.new_price}% OFF)</span>
                  </p>
                  <div className="flex gap-2 mt-3">
                    <Link
                      to={`/product/${selectedVideo.productIds?.[0].id}/${selectedVideo.productIds?.[0].name}`}
                      className="flex-1"
                    >
                      <button className="w-full border border-white text-white text-sm font-semibold py-2 rounded-lg hover:bg-white hover:text-black transition">
                        More Info
                      </button>
                    </Link>
                    <button
                      onClick={() => addToCart(selectedVideo.productIds?.[0].id)}
                      className="flex-1 bg-purple-600 text-white text-sm font-semibold py-2 rounded-lg hover:bg-purple-700 transition"
                    >
                      Add to Cart
                    </button>
                  </div>
                  <a
                    href={`https://wa.me/919944592904?text=Hi%2C%20I%27m%20interested%20in%20${encodeURIComponent(selectedProduct.name || "this product")}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-2 flex items-center justify-center gap-2 w-full py-2 rounded-lg bg-green-500/90 text-white text-sm font-semibold"
                  >
                    <svg className="w-4 h-4 fill-white" viewBox="0 0 24 24"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/><path d="M12 0C5.373 0 0 5.373 0 12c0 2.138.564 4.14 1.541 5.875L0 24l6.299-1.519A11.956 11.956 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.86 0-3.607-.487-5.12-1.34L2 22l1.372-4.768A9.942 9.942 0 012 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z"/></svg>
                    Enquire on WhatsApp
                  </a>
                </div>

                {/* Mobile nav arrows */}
                <button
                  onClick={(e) => { e.stopPropagation(); handleBack(); }}
                  className="absolute left-2 top-1/2 -translate-y-1/2 w-9 h-9 rounded-full bg-black/50 text-white flex items-center justify-center text-sm hover:bg-black/80 transition"
                >❮</button>
                <button
                  onClick={(e) => { e.stopPropagation(); handleNext(); }}
                  className="absolute right-2 top-1/2 -translate-y-1/2 w-9 h-9 rounded-full bg-black/50 text-white flex items-center justify-center text-sm hover:bg-black/80 transition"
                >❯</button>
              </div>

              {/* ── Desktop layout (sm+): side-by-side ── */}
              <div className="hidden sm:flex flex-row h-full overflow-hidden">
                {/* Left: Video */}
                <div className="w-[45%] flex-shrink-0 relative">
                  <video
                    className="w-full h-full object-cover"
                    src={selectedVideo.videoUrl}
                    autoPlay loop muted={isMuted} playsInline
                  />
                </div>

                {/* Right: Details */}
                <div className="flex-1 flex flex-col overflow-hidden">
                  {/* Non-scrollable content */}
                  <div className="flex-1 flex flex-col justify-between p-3 gap-2 overflow-hidden">
                    {/* Product images */}
                    <div className="flex gap-2 overflow-x-auto pb-1" style={{ scrollbarWidth: "none" }}>
                      {selectedProduct?.images?.slice(0, 3).map((img, idx) => (
                        <img
                          crossOrigin="anonymous"
                          key={idx}
                          src={img}
                          alt={`product-${idx}`}
                          className="w-24 h-24 object-cover rounded-lg flex-shrink-0 cursor-pointer hover:scale-105 transition-transform"
                        />
                      ))}
                    </div>

                    {/* Product name + price */}
                    <div>
                      <p className="font-semibold text-gray-900 text-sm leading-snug line-clamp-2">
                        {selectedProduct.name}
                      </p>
                      <p className="text-purple-700 font-bold text-sm mt-0.5">
                        ₹{selectedProduct.old_price && Math.round((selectedProduct.old_price * (100 - selectedProduct.new_price)) / 100)}
                        <span className="text-gray-400 font-normal line-through text-xs ml-2">₹{selectedProduct.old_price}</span>
                        <span className="ml-1 text-green-600 text-xs font-semibold">({selectedProduct.new_price}% OFF)</span>
                      </p>
                    </div>

                    {/* Related Products */}
                    <div>
                      <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">More from this video</p>
                      <div className="flex gap-2 overflow-x-auto pb-1" style={{ scrollbarWidth: "none" }}>
                        {selectedVideo.productIds?.map((product) => (
                          <div
                            key={product._id}
                            className={`flex-shrink-0 cursor-pointer rounded-lg overflow-hidden border-2 transition-all hover:scale-105 ${
                              selectedProduct._id === product._id
                                ? "border-purple-500 shadow-md"
                                : "border-transparent"
                            }`}
                            onClick={() => setSelectedProduct(product)}
                          >
                            <img
                              crossOrigin="anonymous"
                              src={product.images?.[0]}
                              alt={product.name}
                              className="w-16 h-16 object-cover"
                            />
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* Trust badges */}
                    <div className="rounded-xl overflow-hidden border border-purple-100">
                      {[
                        { icon: "🇮🇳", label: "Made in TamilNadu", sub: "Tamil Nadu Crafted", color: "#f97316" },
                        { icon: "👍", label: "Assured Quality",     sub: "100% Genuine",       color: "#8353C6" },
                        { icon: "🚚", label: "Free Shipping",        sub: "On orders ₹499+",   color: "#2563eb" },
                        { icon: "📦", label: "7 Day Returns",        sub: "Hassle-free",        color: "#16a34a" },
                        { icon: "🖨️", label: "Custom Printing",     sub: "Min. 1 meter",       color: "#db2777" },
                      ].map(({ icon, label, sub, color }, i, arr) => (
                        <div
                          key={label}
                          className={`flex items-center gap-2.5 px-3 py-2 bg-white hover:bg-purple-50 transition-colors ${
                            i < arr.length - 1 ? "border-b border-purple-50" : ""
                          }`}
                        >
                          <div
                            className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 text-base"
                            style={{ background: `${color}18` }}
                          >
                            {icon}
                          </div>
                          <div className="flex-1 min-w-0">
                            <p className="text-xs font-semibold text-gray-800 leading-tight">{label}</p>
                            <p className="text-[10px] text-gray-400 leading-tight">{sub}</p>
                          </div>
                          <div className="w-1.5 h-1.5 rounded-full flex-shrink-0" style={{ background: color }} />
                        </div>
                      ))}
                    </div>

                    {/* WhatsApp quick enquiry */}
                    <a
                      href={`https://wa.me/919944592904?text=Hi%2C%20I%27m%20interested%20in%20${encodeURIComponent(selectedProduct.name || "this product")}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center justify-center gap-2 w-full py-1.5 rounded-lg border border-green-500 text-green-700 text-sm font-semibold hover:bg-green-50 transition"
                    >
                      <svg className="w-4 h-4 fill-green-600" viewBox="0 0 24 24"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/><path d="M12 0C5.373 0 0 5.373 0 12c0 2.138.564 4.14 1.541 5.875L0 24l6.299-1.519A11.956 11.956 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.86 0-3.607-.487-5.12-1.34L2 22l1.372-4.768A9.942 9.942 0 012 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z"/></svg>
                      Enquire on WhatsApp
                    </a>
                  </div>

                  {/* Action buttons */}
                  <div className="p-3 border-t flex gap-3 bg-gray-50">
                    <Link
                      to={`/product/${selectedVideo.productIds?.[0].id}/${selectedVideo.productIds?.[0].name}`}
                      className="flex-1"
                    >
                      <button className="w-full border border-purple-600 text-purple-700 text-sm font-semibold py-2 rounded-lg hover:bg-purple-50 transition">
                        More Info
                      </button>
                    </Link>
                    <button
                      onClick={() => addToCart(selectedVideo.productIds?.[0].id)}
                      className="flex-1 bg-purple-600 text-white text-sm font-semibold py-2 rounded-lg hover:bg-purple-700 transition"
                    >
                      Add to Cart
                    </button>
                  </div>
                </div>
              </div>
            </motion.div>

            {/* ── Desktop nav arrows — shown on sm/md (no side cards), hidden on lg (side cards are clickable) ── */}
            <button
              className="hidden sm:flex lg:hidden absolute left-3 top-1/2 -translate-y-1/2 z-[30] w-9 h-9 items-center justify-center rounded-full bg-white/25 text-white hover:bg-white/50 transition text-base"
              onClick={(e) => { e.stopPropagation(); handleBack(); }}
            >❮</button>
            <button
              className="hidden sm:flex lg:hidden absolute right-3 top-1/2 -translate-y-1/2 z-[30] w-9 h-9 items-center justify-center rounded-full bg-white/25 text-white hover:bg-white/50 transition text-base"
              onClick={(e) => { e.stopPropagation(); handleNext(); }}
            >❯</button>
          </div>
        )}
      </div>
    </>
  );
};

export default Videos;

function calculateDiscountPrice(video) {
  if (!video.productIds?.[0]?.old_price) return "";
  return Math.round(
    (video.productIds[0].old_price * (100 - video.productIds[0].new_price)) /
      100
  );
}
